module.exports = __webpack_public_path__ + "static/image/main/card/image-5.ver2_0_2.png?770cdce5";